<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import login from './page/login.vue'

export default {
  name: 'App',
  components: {
    // login
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
.footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0px;
  flex-direction: row;
  justify-content: space-between;
  background-color: #fff;
  width: 100%;
  padding: 10px 0;
  border-top: 1px solid #e6e6e6;
}

.footer-btn {
  width: 90%;
  height: 40px;
  background: #3796f9;
  border-radius: 4px;
  border: none;
  line-height: 40px;
  color: #fff;
  font-size: 15px;
  margin: 0 auto;
}
.switch {
  width: 40px;
  height: 20px;
  border-radius: 10px;
  border: 1px solid #e6e6e6;
}
.switch input {
  display: none;
}
.switch label {
  display: inline-block;
  width: 40px;
  height: 20px;
  background: #999;
  text-align: left;
  border-radius: 10px;
}
.switch input:checked + label {
  background: #3796f9;
  text-align: right;
}
.switch label i {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
}
</style>
